// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { MessageProcessorBase } from './MessageProcessorBase';
import { DirectTokenVerifyMessage } from '@shared/utils/DirectMessages/DirectTokenVerifyMessage';
export class TokenVerifyResponseMessageProcessor extends MessageProcessorBase {
    decode(fs) {
        const msg = new DirectTokenVerifyMessage();
        msg.Login = fs.GetValue(FieldsFactory.FIELD_LOGIN);
        msg.IsExpired = fs.GetValue(FieldsFactory.FIELD_IS_TOKEN_EXPIRED);
        msg.RequestID = fs.GetValue(FieldsFactory.FIELD_REQUEST_ID) || fs.GetValue(FieldsFactory.FIELD_SEQUANCE_ID);
        return [msg];
    }
}
